import { LunaError } from '@vlabs/api-bindings/src/luna-client/LunaError';

import { store } from '@vlapps/luna/src/app/store';
import { logoutSuccess } from '@vlapps/luna/src/features/auth/store';

import { handleError } from '@vlapps/luna/src/components/error-toasts';

function handler(event) {
  const error = event.reason;
  if (error instanceof LunaError && error.status === 401) {
    store.dispatch(logoutSuccess());
  } else {
    handleError(error);
  }
  event.stopPropagation();
  event.preventDefault();
}

export const registerErrorHandlers = () => {
  window.addEventListener('error', handler);
  window.addEventListener('unhandledrejection', handler);
};
